/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Proposals API
 * Moment's Proposals API allows Clients to manage optimization proposals.
 * OpenAPI spec version: 1.0.0
 */

export type AverageValueConstraintType = typeof AverageValueConstraintType[keyof typeof AverageValueConstraintType];


export const AverageValueConstraintType = {
  average_value: 'average_value',
} as const;
